import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.dev';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BotService {

private readonly API_URL = environment.apiUrl;
  api = '';
  headers: HttpHeaders;

  constructor(private http: HttpClient,  private router: Router, private loginService:LoginService) {
    this.headers = new HttpHeaders();
  }
  sendMessage(message: string): Observable<{ response: string }> {
    return this.http.post<any>(this.API_URL + '/bot', { message }).pipe(
      map((res: any) => {
        const text = res?.response || res?.reply || res?.message || res?.data || (typeof res === 'string' ? res : 'No se recibió respuesta válida.');
        return { response: text };
      })
    );
  }

}
